export var MOBILE_WIDTH = 480;
export var TABLET_WIDTH = 1024;
export var MOBILE_NAME = 'mobile';
export var TABLET_NAME = 'tablet';
export var DESKTOP_NAME = 'desktop';
export var DEFAULT_DELAY_TIME = 300;
export var screenTypeDetect = function (value) {
    if (value <= MOBILE_WIDTH) {
        return MOBILE_NAME;
    }
    if (value <= TABLET_WIDTH) {
        return TABLET_NAME;
    }
    return DESKTOP_NAME;
};
